import { RootState } from 'store';

export const selectBlockMessage = (state: RootState) => state.services.api?.blockMessage;
export const selectBlockedFeature = (state: RootState, name: string) =>
  state.services.api?.features?.blockedFeatures?.find(
    (blockedFeature) => blockedFeature.name === name
  );
export const selectInitialized = (state: RootState) => state.services.api?.initialized;
